import { render, staticRenderFns } from "./LogisticsList.vue?vue&type=template&id=21e1b358"
import script from "./LogisticsList.vue?vue&type=script&lang=js"
export * from "./LogisticsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports